import styled from 'styled-components';

import SelfMonitoring from 'components/Icons/SelfMonitoring';
import VatixMonitoring from 'components/Icons/VatixMonitoring';

export const ResponseProfileWrapper = styled('div')`
  color: ${({ theme }) => theme.palette.primary.dark};
  height: 44px;
  display: flex;
  font-size: 1.4rem;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: 100%;
  min-width: 0;
`;

export const StyledChipWrapper = styled('div')`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;

  & > * {
    max-width: 100%;
    min-width: 0;
  }
`;

const StyleMonitoringStatus = `
  fill: ${({ theme }: { theme: { palette: { primary: { main: string }; info: { light: string } } } }) =>
    theme.palette.primary.main};
  font-size: 24px;
  background-color: ${({ theme }: { theme: { palette: { info: { light: string } } } }) => theme.palette.info.light};
  border-radius: 24px;
`;

export const StyledSelfMonitoringStatus = styled(SelfMonitoring)`
  ${StyleMonitoringStatus}
`;

export const StyledVatixMonitoringStatus = styled(VatixMonitoring)`
  ${StyleMonitoringStatus}
`;
